<div class="dig-dialog dialog-confirm">
  <div class="dialog-top-bar">
    <h3 class="m-0">{{ data.mainHeader | transloco }}</h3>
    @if (!data.forcedAgree) {
      <span (click)="closeDialog()" class="icon-close" inlineSVG="/icons/icon-close.svg"></span>
    }
  </div>
  <div class="dialog-content">
    @if (data.subHeader) {
      <h2 class="header">{{ data.subHeader | transloco }}</h2>
    }
    <p class="description">{{ data.description | transloco }}</p>
    @if (data.descriptionItems?.length) {
      <ul class="description-items">
        @for (item of data.descriptionItems; track item) {
          <li>{{ item }}</li>
        }
      </ul>
    }
  </div>
  <div class="dialog-footer">
    @if (!data.forcedAgree) {
      <button class="btn btn-dark-theme btn-grey cta-btn" (click)="closeDialog(false)">
        {{ data.cancelBtnText || 'global.no' | transloco }}
      </button>
    }
    <button
      class="btn btn-dark-theme btn-primary cta-btn"
      [class.center]="data.forcedAgree"
      (click)="closeDialog(true)"
    >
      {{ data.confirmBtnText || 'global.yes' | transloco }}
    </button>
  </div>
</div>
